import React from 'react'
import Page from '../../layouts/Page'

import { FormattedMessage, useIntl } from 'react-intl'
import Container from './Container'

const InfluencerRecap = () => {

  const intl = useIntl()
  return (
    <Page
      title={<FormattedMessage id="creator_summary" defaultMessage={"Creator Summary"} />}
      description={intl.formatMessage({ id: "creator_summary_desc", defaultMessage: "Monitor payments, documents, and economic history for each creator." })}
      breadcrumbs={[
        {
          title: <FormattedMessage id="influencee" defaultMessage={"influencee"} />,
          link: "/"
        },
        {
          title: <FormattedMessage id="creator_summary" defaultMessage={"Creator Summary"} />,
          link: "/influencer-recap"
        },
        
      ]}
    >
      <Container />
    </Page>
  )
}

export default InfluencerRecap